import { createSelectButtonTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * SelectButton Component Configuration
 * 
 * Based on Figma component tokens:
 * - Container (item-bg): surface.raised (neutral.50 #e7e8ec)
 * - Button default: transparent (blends with container)
 * - Button checked (track-on): surface.ground (white) - creates raised effect
 * - Text default: text.tertiary
 * - Text checked: text.secondary (fg---active)
 */
export function createSelectbutton(s: SemanticTokens) {
  const selectButtonTokens = createSelectButtonTokens(s);
  return {
  root: {
    borderRadius: selectButtonTokens.base.radius,
  },
  css: () => `
    p-selectbutton {
      display: inline-flex;
    }
      
    .p-selectbutton {
      background: ${selectButtonTokens.bg};
      padding: ${selectButtonTokens.base.paddingX};
      border-radius: ${selectButtonTokens.base.radius};
      gap: ${selectButtonTokens.base.gap};
      display: inline-flex;
    }

    .p-selectbutton p-togglebutton {
      display: flex;
      align-self: stretch;
    }

    .p-selectbutton .p-togglebutton {
      background: transparent;
      align-items: center;
      align-self: stretch;
      border: 0;
      box-shadow: none;
      color: ${selectButtonTokens.fg};
      font-weight: ${selectButtonTokens.base.fontWeight};
      font-size: ${selectButtonTokens.base.fontSize};
      line-height: ${selectButtonTokens.base.lineHeight};
      padding: ${selectButtonTokens.base.paddingX};
      border-radius: ${selectButtonTokens.base.radius};
      transition: all ${selectButtonTokens.base.transition};
    }

    .p-selectbutton .p-togglebutton .p-togglebutton-label {
      display: block;
    }
    
    .p-selectbutton .p-togglebutton:focus,
    .p-selectbutton .p-togglebutton:focus-visible {
      outline: 0;
      box-shadow: none;
    }
    
    .p-selectbutton .p-togglebutton:not(.p-togglebutton-checked):not([aria-pressed="true"]):hover {
      background: ${selectButtonTokens.bgHover};
      color: ${selectButtonTokens.fg};
    }
    
    .p-selectbutton .p-togglebutton.p-togglebutton-checked,
    .p-selectbutton .p-togglebutton[aria-pressed="true"] {
      background: ${selectButtonTokens.trackOn};
      color: ${selectButtonTokens.fgActive};
      border: 0;
    }
    
    .p-selectbutton .p-togglebutton:disabled,
    .p-selectbutton .p-togglebutton.p-disabled {
      opacity: 1;
    }
    
    .p-selectbutton .p-togglebutton:disabled.p-togglebutton-checked,
    .p-selectbutton .p-togglebutton.p-disabled.p-togglebutton-checked {
      background: ${selectButtonTokens.trackDisabled};
      color: ${selectButtonTokens.fgDisabled};
    }
    
    .p-selectbutton .p-togglebutton:disabled:not(.p-togglebutton-checked),
    .p-selectbutton .p-togglebutton.p-disabled:not(.p-togglebutton-checked) {
      background: transparent;
      color: ${selectButtonTokens.fgDisabled};
    }
    
    /* Disabled container */
    .p-selectbutton.p-disabled,
    .p-selectbutton:has(.p-togglebutton:disabled) {
      background: ${selectButtonTokens.trackDisabled};
    }
    
    .p-selectbutton .p-togglebutton .p-button-label {
      font-weight: ${selectButtonTokens.base.fontWeight};
      font-size: ${selectButtonTokens.base.fontSize};
      line-height: ${selectButtonTokens.base.lineHeight};
    }
  `,
  };
}
export const selectbutton = createSelectbutton(SEMANTIC);